import { render, staticRenderFns } from "./ReceiveMessage.vue?vue&type=template&id=2a761d7b&"
import script from "./ReceiveMessage.vue?vue&type=script&lang=js&"
export * from "./ReceiveMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports